import type { Activity } from "@/types/activity"

/**
 * 액티비티가 어느 날짜의 것인지 — "YYYY-MM-DD" (2026-10-02 요청: 기간 필터).
 *
 * 목록마다 내려주는 필드가 다르다 — /activities/recent-overview 는 startToDate 없이 dateStart(오프셋 포함 ISO)만
 * 내려준다. 둘 다 날짜 부분만 잘라 쓰면 사용자가 화면에서 보는 날짜와 같아진다.
 */
export const activityDateKey = (activity: Pick<Activity, "startToDate" | "dateStart">) =>
  (activity.startToDate || activity.dateStart || "").slice(0, 10)

/** 기간 [start, end] 안의 액티비티인가 — 날짜 단위 양끝 포함 */
export const isActivityInPeriod = (
  activity: Pick<Activity, "startToDate" | "dateStart">,
  period: { start: string; end: string },
) => {
  const date = activityDateKey(activity)
  if (!date) {
    return false
  }

  return (!period.start || date >= period.start) && (!period.end || date <= period.end)
}
